import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { InjectionToken, EventEmitter, Directive, Optional, Inject, Output, Input, HostListener, NgModule } from '@angular/core';

function createImageFromDataUrl(dataURL) {
    return new Promise((res, rej) => {
        const image = new Image();
        image.onload = () => res(image);
        image.onerror = rej;
        image.src = dataURL;
    });
}
function resizeImage(dataURL, { bgColor, maxHeight, maxWidth, quality = 0.7, type = getImageTypeFromDataUrl(dataURL) } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const image = yield createImageFromDataUrl(dataURL);
        if (!document)
            throw new Error('Work only in browser, document not defined');
        const canvas = document.createElement('canvas');
        let height = image.height;
        let width = image.width;
        if (width > maxWidth) {
            height = Math.round(height * maxWidth / width);
            width = maxWidth;
        }
        if (height > maxHeight) {
            width = Math.round(width * maxHeight / height);
            height = maxHeight;
        }
        canvas.width = width;
        canvas.height = height;
        //draw image on canvas
        const ctx = canvas.getContext("2d");
        if (bgColor) {
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        ctx.drawImage(image, 0, 0, width, height);
        // get the data from canvas as 70% jpg (or specified type).
        return canvas.toDataURL(type, quality);
    });
}
function fileToDataURL(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            resolve(reader.result);
        };
        reader.readAsDataURL(file);
    });
}
const typeRE = /^data:([^,;]+)/;
function getImageTypeFromDataUrl(dataURL) {
    let matches = dataURL.match(typeRE);
    return matches && matches[1] || undefined;
}

const IMAGE_FILE_PROCESSOR = new InjectionToken('ImageFileProcessor');
class ImageToDataUrlDirective {
    constructor(imageFileProcessors) {
        this.imageFileProcessors = imageFileProcessors;
        this.imageSelected = new EventEmitter();
        this.options = {};
        this.imageFileProcessors = imageFileProcessors || [];
    }
    ngOnChanges(changes) {
        if (!this.options) {
            this.options = {};
        }
        if (this.options.allowedExtensions) {
            this.options.allowedExtensions = this.options.allowedExtensions.map(ext => ext.toLowerCase());
        }
    }
    readFiles(event) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let file of event.target.files) {
                const result = {
                    file,
                    url: URL.createObjectURL(file)
                };
                let ext = file.name.split('.').pop();
                ext = ext && ext.toLowerCase();
                if (ext && this.options.allowedExtensions
                    && this.options.allowedExtensions.length
                    && this.options.allowedExtensions.indexOf(ext) === -1) {
                    result.error = new Error('Extension Not Allowed');
                }
                else {
                    try {
                        result.dataURL = yield fileToDataURL(file);
                        for (const processor of this.imageFileProcessors) {
                            result.dataURL = yield processor.process(result.dataURL);
                        }
                        result.resized = yield this.resize(result.dataURL, this.options.resize);
                    }
                    catch (e) {
                        result.error = e;
                    }
                }
                this.imageSelected.emit(result);
            }
        });
    }
    resize(dataURL, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options)
                return null;
            const resisedDataUrl = yield resizeImage(dataURL, options);
            return {
                dataURL: resisedDataUrl,
                type: getImageTypeFromDataUrl(resisedDataUrl)
            };
        });
    }
}
ImageToDataUrlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlDirective, deps: [{ token: IMAGE_FILE_PROCESSOR, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ImageToDataUrlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.0", type: ImageToDataUrlDirective, selector: "input[type=file][imageToDataUrl]", inputs: { options: ["imageToDataUrl", "options"] }, outputs: { imageSelected: "imageSelected" }, host: { listeners: { "change": "readFiles($event)" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[type=file][imageToDataUrl]'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [IMAGE_FILE_PROCESSOR]
                    }] }];
    }, propDecorators: { imageSelected: [{
                type: Output
            }], options: [{
                type: Input,
                args: ['imageToDataUrl']
            }], readFiles: [{
                type: HostListener,
                args: ['change', ['$event']]
            }] } });

class ImageToDataUrlModule {
}
ImageToDataUrlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ImageToDataUrlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlModule, declarations: [ImageToDataUrlDirective], exports: [ImageToDataUrlDirective] });
ImageToDataUrlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.0", ngImport: i0, type: ImageToDataUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ImageToDataUrlDirective],
                    exports: [ImageToDataUrlDirective]
                }]
        }] });

/*
 * Public API Surface of ngx-image2dataurl
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IMAGE_FILE_PROCESSOR, ImageToDataUrlDirective, ImageToDataUrlModule, createImageFromDataUrl, getImageTypeFromDataUrl };
